<template>
  <div class="help_box flex" ref="multipleTable">
    <div class="item">
      <span class="txt" style="margin-left:3%">总数量：</span>
      <el-input v-model="fromData.orderQuantityTotal" placeholder="暂无总数量" @change="ConfirmScrapChange"></el-input>
      <el-input v-model="fromData.entryUnitDesc" placeholder="计量单位" style="width:20%;margin-left:5%"></el-input>
    </div>

    <div class="item">
      <span class="txt" style="margin-left:3%">报废部分：</span>
      <el-input v-model="fromData.orderConfirmScrap" placeholder="暂无报废部分" :disabled="true"></el-input>
      <el-input v-model="fromData.batchCharacter" placeholder="暂无" :disabled="true" style="width:32%">
          <template slot="append" >%</template>
      </el-input>

    </div>

    <div class="item">
      <span class="txt">已交货：</span>
      <el-input v-model="fromData.deliveryQty" placeholder="暂无" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">缺量/过量收货：</span>
      <el-input v-model="fromData.nachl" placeholder="暂无" :disabled="true"></el-input>
    </div>

    <!-- <div class="item">
    <span class="txt">基本日期：</span>
      <el-date-picker
        v-model="fromData.basicDate"
        type="daterange"
        :clearable=false 
        :editable=false
        range-separator="至"
        start-placeholder="基本开始日期"
        end-placeholder="基本结束日期">
      </el-date-picker>
    </div> -->
    <div class="item">
      <span class="txt">基本开始日期：</span>
      <el-date-picker v-model="fromData.orderStartDate" type="date" placeholder="选择日期" :disabled="true"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">确认开始日期：</span>
      <el-date-picker v-model="fromData.actualStartDate" type="date" placeholder="选择日期" :disabled="true"></el-date-picker>
    </div>

    <!-- <div class="item">
    <span class="txt">确定日期：</span>

      <el-date-picker
        v-model="fromData.determineCompleteDate"
        type="daterange"
        :clearable=false 
        :editable=false
        range-separator="至"
        start-placeholder="确定开始日期"
        end-placeholder="确定结束日期">
      </el-date-picker>
    </div> -->

    <div class="item">
      <span class="txt">基本结束日期：</span>
      <el-date-picker v-model="fromData.basicCompletionDate" type="date" placeholder="选择日期" :disabled="true"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">确认结束日期：</span>
      <el-date-picker v-model="fromData.determineCompleteDate" type="date" placeholder="选择日期" :disabled="true"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">确认审批日期：</span>
      <el-date-picker v-model="fromData.actualReleaseDate" type="date" placeholder="选择日期" :disabled="true"></el-date-picker>
    </div>

   
  </div>
</template>

<script>
import { fstockApi, customerApi, matterApi } from "api/base.js";
import { targetUnit } from "api/business.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  props: {
    noFromData: Object,
    factoryList: Array,
    fromData: Object,

    materialList: Array,
    distriChannelList: Array,
    salesPriceList: Array,
    priceUnitList: Array,
    basicUnitList: Array
  },
  data() {
    return {
      getAllPage: this.$store.state.getAllPage
    };
  },
  created() {
    //开始日期和结束日期默认今天
    // let nowData = new Date();
    // let arr = [this.fromData.validStartDate,this.fromData.validEndDate];
    // this.$set(this.fromData, "validDate", arr);
  },
  computed: {},
  methods: {
    ...mapActions("cache", [
      // "setMaterialList",
      // "setDistriChannelList",
      // "setSalesPriceList",
      // "setPriceUnitList",
      // "setBasicUnitList",
      "setSelectedProductOrderMaterial"
    ]),

    //取消选择
    cancelSelect() {
      this.$refs.multipleTable.cancelSelect();
    },
    ConfirmScrapChange(val){
        console.log(val)
        this.fromData.batchCharacter = this.fromData.orderConfirmScrap / val * 100
    },

  }
};
</script>

<style>
</style>
